import PropTypes from 'prop-types';

import { JobExternalStakeholdersPopupType } from 'src/components/CapBox/constants';

export const JobExternalStakeholdersPopupComponentPropTypes = {
  companyTypes: PropTypes.array,
  disabled: PropTypes.bool.isRequired,
  job: PropTypes.object.isRequired,
  jobId: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  serviceType: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(JobExternalStakeholdersPopupType)).isRequired,
  excludedUsersIds: PropTypes.arrayOf(PropTypes.number),
};

export const JobAddNewContactFormComponentPropTypes = {
  affiliationOptionsList: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  disabled: PropTypes.bool.isRequired,
  inputEmail: PropTypes.string.isRequired,
  inputFirstName: PropTypes.string.isRequired,
  inputLastName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  selectedAffiliation: PropTypes.shape({ value: PropTypes.number.isRequired, label: PropTypes.string.isRequired }),
  setInputEmail: PropTypes.func.isRequired,
  setInputFirstName: PropTypes.func.isRequired,
  setInputLastName: PropTypes.func.isRequired,
  setNewContactFormError: PropTypes.func.isRequired,
  setSelectedAffiliation: PropTypes.func.isRequired,
};

/* DefaultProps */

export const JobExternalStakeholdersPopupComponentDefaultProps = {
  companyTypes: [],
  excludedUsersIds: [],
};
